
export default class LargeCard {

	static getHolderSelectors = () => ['.large-card-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
	}

}
